import './Download.css';



function Download(){

    setTimeout(function(){

        window.location='https://natural-seducer.web.app/success';
    
      },5000)
    
    // https://srv-store2.gofile.io/download/qY8b9z/Change%20Your%20Mind%2C%20Change%20Your%20Life%20_%20The%20U%20-%20John%20WALKER.epub

    return(
        <>
        
            <div class="center">
            <a id="clicked" href="http://download1475.mediafire.com/6u1b7sgdbaug/pbnwsiquomhoywd/Change+Your+Mind%2C+Change+Your+Life+_+The+U+-+John+WALKER.epub" download="Change Your Mind, Change Your Life _ The U - John WALKER"> 
                <button class="invisible"> Download </button>
            </a>
            </div>
            
        
        </>
    );
}

export default Download;